<template>
  <div>
    <div class="newhomepage-style" v-if="isMobile">
      <toppage></toppage>
      <div class="newhomepage-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>成都北鸣</h1>
            <h3>CHENGDUBEIMING</h3>
            <div class="header-bottom">
              <span>专家级区块链追溯及安全解决方案供应商</span>
              <img
                src="../../assets/image/mobile/newhomepage/bannerline.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="main-product">
          <div class="product-header">
            <h1>图链</h1>
            <span class="header-title">虚拟货币智能分析系统 </span>
            <span class="header-line"> 公安部经侦应用云推荐研判工具 </span>
          </div>
          <div class="title-content">
            <div class="block">
              <el-carousel :height="bannerHeight1 + 'px'">
                <el-carousel-item>
                  <img
                    src="../../assets/image/mobile/newhomepage/01.png"
                    alt=""
                    class="product-img"
                  />
                </el-carousel-item>
                <el-carousel-item>
                  <img
                    src="../../assets/image/mobile/newhomepage/02.png"
                    alt=""
                    class="product-img"
                  />
                </el-carousel-item>
                <el-carousel-item>
                  <img
                    src="../../assets/image/mobile/newhomepage/03.png"
                    alt=""
                    class="product-img"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="content-button">
            <a
              href="https://graphchain.feishu.cn/share/base/form/shrcnwy8omau58IAfPyF8jSIL2d?ccm_open_type=form_v2_link_share"
              target="_blank"
            >
              联系试用</a
            >
          </div>
        </div>
        <div class="main-corebusiness">
          <h1>核心业务</h1>
          <div class="corebusiness-content">
            <router-link to="/moneyinvolved" class="animated-element">
              <div class="Assist-content">
                <div class="content-info">
                  <span>涉币案件司法协助</span>
                  <span
                    >解决虚拟币案件的司法痛点，为司法机关提供有力的证据支持</span
                  >
                </div>
                <div class="content-img">
                  <img src="@/assets/image/newhome/Assist1.png" alt="" />
                </div></div
            ></router-link>
            <router-link class="animated-element" to="/dataasset">
              <div class="Assist-content1">
                <div class="content-img">
                  <img src="@/assets/image/newhome/figureassets1.png" alt="" />
                </div>
                <div class="content-info">
                  <span>数字资产挽损</span>
                  <span
                    >迅速定位问题，分析原因，制定有效的挽损方案为您的资产安全保驾护航</span
                  >
                </div>
              </div></router-link
            >
            <router-link to="/serviceprocess" class="animated-element1">
              <div class="Assist-content">
                <div class="content-info">
                  <span>安全审计服务</span>
                  <span
                    >提供区块链资金安全、共识安全、挖掘智能合约相关项目的源码，根据业务逻辑进行多维度的安全审计服务</span
                  >
                </div>
                <div class="content-img">
                  <img src="@/assets/image/newhome/assetsteam1.png" alt="" />
                </div></div
            ></router-link>
            <router-link to="/onchainatm" class="animated-element">
              <div class="Assist-content1">
                <div class="content-img">
                  <img src="@/assets/image/newhome/onchainaml1.png" alt="" />
                </div>
                <div class="content-info">
                  <span>链上AML服务</span>
                  <span
                    >保证数据的安全性和隐私性的情况下，高效协助政府机构识别和打击加密货币相关犯罪，快速开展虚拟资产合规与业务风险防控</span
                  >
                </div>
              </div></router-link
            >
          </div>
        </div>
        <div class="main-technology">
          <div class="technology-info animated-element">
            <h1>技术能力</h1>
            <img
              src="@/assets/image/mobile/newhomepage/technologybg.png"
              alt=""
            />
            <!-- <div class="technology-main">
                  <img src="../../assets/image/mobile/newhomepage/shouye.png" alt="" />
                  <div class="analyze-info">
                  
                    <div class="analyze-main">
                      <span class="analyze-right">
                        <img
                          src="../../assets/image/homePage/group1.png"
                          alt=""
                        />
                      </span>
                      <span class="analyze-left">
                        <h3>分析团队</h3>
                        <span
                          >核心分析成员均来自火<br />
                          币、币安、OK等大型交易所</span
                        >
                      </span>
                
                    </div>
                  </div>
                  <div class="analyze-info1">
                  
                    <div class="analyze-main">
                      <span class="analyze-right">
                        <img
                          src="../../assets/image/homePage/group1.png"
                          alt=""
                        />
                      </span>
                      <span class="analyze-left">
                        <h3>资产团队</h3>
                        <span>合规资产团队 <br />十亿级资产处理经验</span>
                      </span>
                    
                    </div>
                  </div>
                  <div class="analyze-info2">
                  
                    <div class="analyze-main">
                      <span class="analyze-right">
                        <img
                          src="../../assets/image/homePage/group3.png"
                          alt=""
                        />
                      </span>
                      <span class="analyze-left">
                        <h3>技术团队</h3>
                        <span>技术开发成员均来自 <br />百度、华为等大厂</span>
                      </span>
                    </div>
                  </div>
                </div> -->
          </div>
        </div>
        <div class="main-profession">
          <h1>7年行业经验</h1>
          <p>
            北鸣将大数据、人工智能等核心技术与应用场景结合，在案件配侦等领域持续发力，业务覆盖安全审计、威胁情报、防御部署等服务并配套有图链虚拟货币安全智能研判系统、加密货币反洗钱（AML）等SaaS型安全产品，与浙江、云南、贵州、河南、山东、湖北、湖南、江西等政府机构、公安单位建立良好合作关系，获得业界的广泛认可。
          </p>
          <div class="profession-main">
            <div class="main-content">
              <img src="@/assets/image/newhome/kehu.png" alt="" />
              <span> <span id="serviceclient1"></span><span>+</span> </span>
              <span>服务客户 </span>
            </div>
            <div class="main-content">
              <img src="@/assets/image/newhome/fuwu.png" alt="" />
              <span> <span id="trainservice1"></span><span>次+</span></span>
              <span>培训服务 </span>
            </div>
            <div class="main-content">
              <img src="@/assets/image/newhome/biaoqian.png" alt="" />
              <span><span id="malicelabel1"></span><span>万+</span></span>
              <span>恶意标签</span>
            </div>
            <div class="main-content">
              <img src="@/assets/image/newhome/jine.png" alt="" />
              <span><span id="Refertomoney1"></span><span>亿+</span></span>
              <span>涉案金额</span>
            </div>
          </div>
        </div>
        <div class="main-bottom">
          <h1>联系我们</h1>
          <span class="bottom-info">
            <span>官方邮箱</span>
            <span>business@graphchain.top</span>
          </span>
          <span class="bottom-info">
            <span>工作时间</span>
            <span>周一至周五 9:30 - 18:30</span>
          </span>
          <span class="bottom-info">
            <span>公司总部</span>
            <span>成都市武侯区交子大道中海国际D座4-8楼</span>
          </span>
          <div id="amap-container" class="map-style"></div>
          <div class="footer-bottomright">
            <div class="footer-info">
              <b>微信公众号</b>
              <span class="footer-mainimage">
                <img
                  src="@/assets/image/mobile/newhomepage/wechat.png"
                  alt=""
                />
              </span>
            </div>
            <div class="footer-info">
              <b>客服微信</b>
              <span class="footer-mainimage">
                <img
                  src="@/assets/image/mobile/newhomepage/weixinkefu.png"
                  alt=""
                />
              </span>
            </div>
          </div>
        </div>
        <footerpage></footerpage>
      </div>
      <img
        class="scroll-button"
        v-if="showButton"
        @click="scrollToTop"
        src="../../assets/image/newhome/huidaodingbu.png"
        alt=""
      />
    </div>
    <div class="newhomepage-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section newhomepage-top">
          <div class="newhomepage-nav">
            <navbar classname="home"></navbar>
          </div>
          <div class="newhomepage-video-box">
            <video
              id="newhomevideo"
              autoplay
              muted
              loop
              class="newhomepage-video"
            >
              <source
                src="../../assets/image/homePage/videopng.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div class="section-content">
            <div class="top-title">
              <div class="title-info">
                <h1>成都北鸣</h1>
                <span>CHENGDUBEIMING</span>
              </div>
              <div class="title-content">
                <span>专家级区块链追溯及安全解决方案供应商</span>
                <img src="@/assets/image/newhome/bannerline.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="section newhomepage-product">
          <div class="product-content">
            <div class="top-title">
              <div class="title-info">
                <h1>图链</h1>
                <span>虚拟货币智能分析系统 </span>
                <span> 公安部经侦应用云推荐研判工具 </span>
              </div>
              <div class="title-content">
                <div class="block">
                  <el-carousel :height="bannerHeight + 'px'">
                    <el-carousel-item>
                      <img
                        src="../../assets/image/newhome/product1.png"
                        alt=""
                        class="product-img"
                      />
                    </el-carousel-item>
                    <el-carousel-item>
                      <img
                        src="../../assets/image/newhome/product2.png"
                        alt=""
                        class="product-img"
                      />
                    </el-carousel-item>
                    <el-carousel-item>
                      <img
                        src="../../assets/image/newhome/product3.png"
                        alt=""
                        class="product-img"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              <div class="content-button">
                <a
                  href="https://graphchain.feishu.cn/share/base/form/shrcnwy8omau58IAfPyF8jSIL2d?ccm_open_type=form_v2_link_share"
                  target="_blank"
                >
                  联系试用</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="section newhomepage-corebusiness">
          <div class="corebusiness-content">
            <div
              class="corebusiness-box animated-element"
              v-show="iscorebusiness1"
            >
              <div class="corebusiness-title animated-element">
                <h1>核心业务</h1>
              </div>

              <router-link to="/moneyinvolved" class="animated-element">
                <div class="Assist-content">
                  <div class="content-info">
                    <span>涉币案件司法协助</span>
                    <span
                      >解决虚拟币案件的司法痛点，为司法机关提供有力的证据支持</span
                    >
                  </div>
                  <div class="content-img">
                    <img src="@/assets/image/newhome/Assist1.png" alt="" />
                  </div></div
              ></router-link>
              <router-link class="animated-element" to="/dataasset">
                <div class="Assist-contentright">
                  <div class="content-img">
                    <img
                      src="@/assets/image/newhome/figureassets1.png"
                      alt=""
                    />
                  </div>
                  <div class="content-info">
                    <span>数字资产挽损</span>
                    <span
                      >迅速定位问题，分析原因，制定有效的挽损方案为您的资产安全保驾护航</span
                    >
                  </div>
                </div></router-link
              >
            </div>
          </div>
        </div>
        <div
          class="section newhomepage-corebusiness"
          style="background-color: #fff"
        >
          <div class="corebusiness-content">
            <div
              class="corebusiness-box animated-element"
              v-show="iscorebusiness2"
            >
              <!-- <div class="corebusiness-title">
                   <h1>核心业务</h1>
                  </div> -->
              <router-link to="/serviceprocess" class="animated-element1">
                <div class="Assist-content">
                  <div class="content-info">
                    <span>安全审计服务</span>
                    <span
                      >提供区块链资金安全、共识安全、挖掘智能合约相关项目的源码，根据业务逻辑进行多维度的安全审计服务</span
                    >
                  </div>
                  <div class="content-img">
                    <img src="@/assets/image/newhome/assetsteam1.png" alt="" />
                  </div></div
              ></router-link>
              <router-link to="/onchainatm" class="animated-element">
                <div class="Assist-contentright">
                  <div class="content-img">
                    <img src="@/assets/image/newhome/onchainaml1.png" alt="" />
                  </div>
                  <div class="content-info">
                    <span>链上AML服务</span>
                    <span
                      >保证数据的安全性和隐私性的情况下，高效协助政府机构识别和打击加密货币相关犯罪，快速开展虚拟资产合规与业务风险防控</span
                    >
                  </div>
                </div></router-link
              >
            </div>
          </div>
        </div>
        <div class="section newhomepage-technology">
          <div class="technology-content">
            <div class="technology-box animated-element" v-show="istechnology">
              <div class="technology-info animated-element">
                <h1>技术能力</h1>
                <div class="technology-main">
                  <img src="../../assets/image/homePage/shouye.png" alt="" />
                  <div class="analyze-info">
                    <!-- <img src="@/assets/image/newhome/analyze.png" alt="" /> -->
                    <div class="analyze-main">
                      <span class="analyze-left">
                        <h3>分析团队</h3>
                        <span
                          >核心分析成员均来自火<br />
                          币、币安、OK等大型交易所</span
                        >
                      </span>
                      <span class="analyze-right">
                        <img
                          src="../../assets/image/homePage/group1.png"
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                  <div class="analyze-info1">
                    <!-- <img src="@/assets/image/newhome/analyze.png" alt="" /> -->
                    <div class="analyze-main">
                      <span class="analyze-left">
                        <h3>资产团队</h3>
                        <span>合规资产团队 <br />十亿级资产处理经验</span>
                      </span>
                      <span class="analyze-right">
                        <img
                          src="../../assets/image/homePage/group1.png"
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                  <div class="analyze-info2">
                    <!-- <img src="@/assets/image/newhome/analyze.png" alt="" /> -->
                    <div class="analyze-main">
                      <span class="analyze-right">
                        <img
                          src="../../assets/image/homePage/group3.png"
                          alt=""
                        />
                      </span>
                      <span class="analyze-left">
                        <h3>技术团队</h3>
                        <span>技术开发成员均来自 <br />百度、华为等大厂</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="technology-main animated-element">
                <img src="../../assets/image/homePage/shouye.png" alt="">
                <div class="analyze-main">
  
                  <div class="analyze-info">
                    <img src="@/assets/image/newhome/analyze.png" alt="" />
                    <span>分析团队</span>
                    <span>核心分析成员均来自火<br/> 币、币安、OK等大型交易所</span>
                  </div>
                  <div class="analyze-info">
                    <img src="@/assets/image/newhome/technology.png" alt="" />
                    <span>技术团队</span>
                    <span>技术开发成员均来自 <br/>百度、华为等大厂</span>
                  </div>
                  <div class="analyze-info">
                    <img src="@/assets/image/newhome/assets.png" alt="" />
                    <span>资产团队</span>
                    <span>合规资产团队 <br/>十亿级资产处理经验</span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="section newhomepage-profession">
          <div
            class="profession-content animated-element1"
            v-show="isprofession"
          >
            <div class="profession-box">
              <div class="profession-info">
                <h1>7年行业经验</h1>
                <p>
                  北鸣将大数据、人工智能等核心技术与应用场景结合，在案件配侦等领域持续发力，业务覆盖安全审计、威胁情报、防御部署等服务并配套有图链虚拟货币安全智能研判系统、加密货币反洗钱（AML）等SaaS型安全产品，与浙江、云南、贵州、河南、山东、湖北、湖南、江西等政府机构、公安单位建立良好合作关系，获得业界的广泛认可。
                </p>
                <div class="profession-main">
                  <div class="main-content">
                    <img src="@/assets/image/newhome/kehu.png" alt="" />
                    <span>
                      <span id="serviceclient"></span><span>+</span>
                    </span>
                    <span>服务客户 </span>
                  </div>
                  <div class="main-content">
                    <img src="@/assets/image/newhome/fuwu.png" alt="" />
                    <span>
                      <span id="trainservice"></span><span>次+</span></span
                    >
                    <span>培训服务 </span>
                  </div>
                  <div class="main-content">
                    <img src="@/assets/image/newhome/biaoqian.png" alt="" />
                    <span><span id="malicelabel"></span><span>万+</span></span>
                    <span>恶意标签</span>
                  </div>
                  <div class="main-content">
                    <img src="@/assets/image/newhome/jine.png" alt="" />
                    <span><span id="Refertomoney"></span><span>亿+</span></span>
                    <span>涉案金额</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/navbar.vue";
import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";

import newfooter from "@/components/newfooter.vue";
// import countTo  from 'vue-count-to';
import CountUp from "countup";
export default {
  components: {
    navbar,
    newfooter,
    toppage,
    footerpage,
    // countTo
  },
  data() {
    return {
      showButton: false,
      scrollThreshold: 400,
      isMobile: false,
      istechnology: false,
      iscorebusiness1: false,
      iscorebusiness2: false,
      isprofession: false,
      screenWidth: 0,
      bannerHeight: 0,
      bannerHeight1: 0,

      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true,
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,
        //为每个section设置背景色
        // sectionsColor: [
        //     "#41b883",
        //     "#ff5f45",
        //     "#0798ec",
        //     "#fec401",
        //     "#1bcee6",
        //     "#ee1a59",
        //     "#2c3e4f",
        //     "#ba5be9",
        //     "#b4b8ab"
        // ],
      },
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    // onLeave(index, direction){
    //   console.log(index, direction);
    // },
    afterLoad(anchorLink, index) {
      console.log(anchorLink, index);
      //获取body的classname，跟随section滑动刷新
      let a = document.body.className;
      console.log(a);
      //在第几页控制相关逻辑
      if (a !== "fp-scroll-mac fp-viewing-3" || a !== "fp-viewing-3") {
        this.iscorebusiness2 = false;
      }
      if (a !== "fp-scroll-mac fp-viewing-4" || a !== "fp-viewing-4") {
        this.istechnology = false;
      }
      if (a !== "fp-scroll-mac fp-viewing-2" || a !== "fp-viewing-2") {
        this.iscorebusiness1 = false;
      }
      if (a !== "fp-scroll-mac fp-viewing-5" || a !== "fp-viewing-5") {
        this.isprofession = false;
      }
      if (a === "fp-scroll-mac fp-viewing-5" || a === "fp-viewing-5") {
        // console.log(eee);
        this.isprofession = true;
        setTimeout(() => {
          this.numberScroll();
        }, 100);
      } else if (a === "fp-scroll-mac fp-viewing-3" || a === "fp-viewing-3") {
        this.iscorebusiness2 = true;
      } else if (a === "fp-scroll-mac fp-viewing-2" || a === "fp-viewing-2") {
        this.iscorebusiness1 = true;
      } else if (a === "fp-scroll-mac fp-viewing-4" || a === "fp-viewing-4") {
        this.istechnology = true;
      } else if (a === "fp-scroll-mac fp-viewing-0" || a === "fp-viewing-0") {
        // this.istechnology = true;
        console.log("第一页");
        var video = document.getElementById("newhomevideo");
        console.log(video);
        video.play();
      }
    },

    numberScroll() {
      let count = new CountUp("serviceclient", 0, 200, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count.error) {
        count.start();
      } else {
        console.log(count.error);
      }
      let count1 = new CountUp("trainservice", 0, 500, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count1.error) {
        count1.start();
      } else {
        console.log(count1.error);
      }
      let count2 = new CountUp("malicelabel", 0, 1800, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count2.error) {
        count2.start();
      } else {
        console.log(count2.error);
      }
      let count3 = new CountUp("Refertomoney", 0, 10000, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count3.error) {
        count3.start();
      } else {
        console.log(count3.error);
      }
    },
    numberScroll1() {
      let count = new CountUp("serviceclient1", 0, 200, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count.error) {
        count.start();
      } else {
        console.log(count.error);
      }
      let count1 = new CountUp("trainservice1", 0, 500, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count1.error) {
        count1.start();
      } else {
        console.log(count1.error);
      }
      let count2 = new CountUp("malicelabel1", 0, 1800, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count2.error) {
        count2.start();
      } else {
        console.log(count2.error);
      }
      let count3 = new CountUp("Refertomoney1", 0, 10000, 0, 1, {
        duration: 1,
        useEasing: false,
      });
      if (!count3.error) {
        count3.start();
      } else {
        console.log(count3.error);
      }
    },
    next() {
      // 向下滚动一页
      this.$refs.fullpage.api.moveSectionDown();
    },
    initAMap() {
      // 高德地图API加载完成后执行初始化
      this.$nextTick(() => {
        var map = new AMap.Map("amap-container", {
          zoom: 13, // 设置地图缩放级别
          center: [104.056544, 30.582004], // 设置地图中心点
        });
        //  navigator.geolocation.getCurrentPosition(
        // (position) => {
        //   console.log(position);
        // const latitude = position.coords.latitude;
        // const longitude = position.coords.longitude;
        // const currentPosition = [longitude, latitude];
        var marker = new AMap.Marker({
          position: [104.056544, 30.582004], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: "成都市武侯区交子大道中海国际D座4-8楼",

          label: {
            offset: new AMap.Pixel(30, 30), //修改label相对于maker的位置
            content: " 成都市武侯区交子大道中海国际D座4-8楼",
          },
        });
        map.add(marker);
        marker.on("click", function (e) {
          marker.markOnAMAP({
            name: " 成都市武侯区交子大道中海国际D座4-8楼",
            position: marker.getPosition(),
          });
        });

        // 移动地图中心到当前位置
        //   map.setCenter(currentPosition);
        // },
        //     (error) => {
        // if (error.code === error.PERMISSION_DENIED) {
        //   // 用户拒绝了地理位置权限
        //   alert("请授予地理位置权限以使用该功能。");
        // } else {
        //   // 其他错误，处理方式
        // }}
        //   );

        // 添加地图控件，如缩放控件
        // AMap.plugin(["AMap.ToolBar"], function () {
        //   var toolbar = new AMap.ToolBar();
        //   map.addControl(toolbar);
        // });
      });
    },
  },
  mounted() {
    if (this.deviceType != "手机" && !this.isMobile) {
      // this.next();
    }
    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth;
    this.bannerHeight = (450 / 1450) * this.screenWidth;
    this.bannerHeight1 = (550 / 1280) * this.screenWidth;
    // 窗口大小发生改变
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (450 / 1450) * this.screenWidth;
      this.bannerHeight1 = (550 / 1280) * this.screenWidth;
    };
    if (this.isMobile) {
      this.numberScroll1();
    }
    this.initAMap();
    if (this.isMobile) {
      window.addEventListener("scroll", () => {
        this.showButton = window.scrollY > this.scrollThreshold;
      });
    }
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", () => {});
  },
};
</script>
<style>
.fp-warning,
.fp-watermark {
  display: none !important;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/newhomepage.scss";
</style>
